<div class="page-container">
  <!-- Wrapper Card for consistent design -->
  <div class="task-viewer-card">
    <app-task-viewer
      (taskClosed)="onTaskClosed()"
      (taskUpdated)="onTaskUpdated($event)"
    ></app-task-viewer>
  </div>
</div>
